export class DashboardDeviceStatus {

    private label: string;
    count: number;

    constructor(label?: string,
                count?: number) {
                    this.label = label;
                    this.count = count;
        }

    public get Label(): string {
        return this.label;
    }
    public get Count(): number {
        return this.count;
    }


    public set Label(label: string) {
        this.label = label;
    }
    public set Count(count: number) {
        this.count = count;
    }

}
